<template>
<div class="flex flex-grow">
  <div class="flex w-full border-black border-b-2"  
  v-bind:class="{'bg-gray-300 font-bold': isSunday, 'bg-maroon bg-opacity-25 font-bold': isToday}"
  v-show="this.show">
    <div class="w-1/8 pl-1 pr-2 py-1">{{ day_str }}.&nbsp;{{ day_name }} </div>
    <div class="w-full py-1">
      <ul>
        <li class="w-auto pr-2 text-left" v-for="event in this.event_list" :key=event.date>
          <span  v-if="event.ho < 1">
            {{ event.event_text }}
          </span>
          <span class="font-bold"  v-if="event.ho >= 1">
            {{ event.event_text }}
          </span>
          <a class="icsLink" :href="'data:text/plain;charset=utf-8,' + event.ics_str" :download="event.date.getFullYear() + '_' + event.name + '.ics'"> (ics)</a>
        </li>
      </ul>
    </div>
  </div>
  <div class="flex w-full items-center border-black border-b-2"  v-if="this.duration > 1">
    <ul class="w-1/8">
      <template v-for="n in this.duration" :key=n>
        <li class="py-2 pl-1 pr-2 text-left bg-gray-300 font-bold" v-if="days_names[n-1]=='So'">{{ day_strs[n-1] }}.&nbsp;{{ days_names[n-1]}}
        </li>
        <li class="py-2 pl-1 pr-2 text-left" v-else>{{ day_strs[n-1] }}.&nbsp;{{ days_names[n-1]}}</li>
       </template>
    </ul>
    <div class="flex items-center h-full w-full pl-1 pr-2 py-1 bg-gray-100 justify-center">
      <span>{{ this.event_name }}
        <a class="icsLink" :href="'data:text/plain;charset=utf-8,' + this.ics_str" :download="this.date.getFullYear() + '_' + this.event_name + '.ics'"> (ics)</a>
      </span>
    </div>
  </div>
</div>
</template>

<script>
const zeroPad = (num, places) => String(num).padStart(places, '0')
var day_names = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
export default {
  name: "ProgramDay",
  props: ["date"],
  data() { // return empty values to allow waiting for mount to fill data
    return {
      day_str: "",
      isSunday: false,
      isToday: false,
      day_name: "",
      event_list: [],
      show: true,
      duration: 1,
      day_strs: [],
      days_names: [],
      event_name: "",
      ics_str: ""
    }
  },
  mounted() {
    const key = this.date.getTime();

    if (this.$events && key in this.$events) {
      this.event_list.push(...this.$events[key]);

      for (let i = 0; i < this.event_list.length; i++) {
        const event = this.event_list[i];
        this.duration = Math.max(this.duration, event.duration);

        if (event.precision === "dead") {
          this.show = false;
        } else {
          if (event.date.getHours() === 0 && event.date.getMinutes() === 0) {
            event.event_text = event.name;
          } else {
            switch (event.date.getMinutes()) {
              case 0: event.precision = " st"; break;
              case 15: event.precision = " ct"; break;
              case 30: event.precision = " mt"; break;
              default:
                event.precision = ":" + zeroPad(event.date.getMinutes(), 2);
                break;
            }
            event.event_text = zeroPad(event.date.getHours(), 2) + event.precision + ' ' + event.name;
          }
        }
      }

      if (this.duration > 1) {
        this.show = false;
        this.event_name = this.event_list[0].name;
        this.ics_str = this.event_list[0].ics_str;
        for (let d = 0; d < this.duration; d++) {
          this.day_strs.push(zeroPad(this.date.getDate() + d, 2));
          this.days_names.push(day_names[(this.date.getDay() + d) % 7]);
        }
      }
    }

    this.isSunday = this.date.getDay() === 0;
    this.day_str = zeroPad(this.date.getDate(), 2);
    this.day_name = day_names[this.date.getDay()];
    this.isToday = new Date().toDateString() === this.date.toDateString();
  },
  computed:{
  }
};
</script>

<style>
a.icsLink {
  font-size: x-small;
}
</style>